/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Inherited_Banner_DescriptionInputs */



/**
* | output |
* | --- |
* | "You're not a member of this space. You can see it because a project you belong to links it — the same access the AI uses to answer from it. Read-only, and it..." |
*
* @param {Spaces_Inherited_Banner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_inherited_banner_description = /** @type {((inputs?: Spaces_Inherited_Banner_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Inherited_Banner_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du bist kein Mitglied dieses Spaces. Du siehst ihn, weil ein Projekt, dem du angehörst, ihn verknüpft hat — genau der Zugriff, mit dem die KI daraus antwortet. Nur lesend, und er endet mit der Verknüpfung oder deiner Projektmitgliedschaft.")
	return /** @type {LocalizedString} */ ("You're not a member of this space. You can see it because a project you belong to links it — the same access the AI uses to answer from it. Read-only, and it ends when the link or your project membership does.")
});